// Router using https://visionmedia.github.io/page.js/
// Last Updated 2020: React, VueJS and Angular probably took over.
// Flo still likes the simplicity of this front end router
//
import page from 'page'
import appStarterPg from '../../../config/app-starter-pg.js'

import { contentElementId } from '../../../config/config.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { showAdminListSyncs } from './list-syncs/index.js'
import { showAdminSyncDetails } from './sync-details/index.js'

/*
  Admin: data syncs
*/

export function setupDataSyncsRoutes (baseRoute) {
  /**
   * Can be used for all entities or a specific one
   */
  page(`${baseRoute}`, async function (context) {
    console.log('admin/data-syncs', context)

    // const url = new URL(location.href)
    // const searchParams = new URLSearchParams(url?.search)
    const searchParams = new URLSearchParams(context?.querystring)
    // console.log('searchParams', searchParams, searchParams.keys())
    // console.log('searchParams', searchParams.toString())

    const accountingOrganisationId = searchParams.get('accountingOrganisationId')

    await appStarterPg()

    showAdminListSyncs({
      containerElementId: contentElementId,
      browserAppUser,
      accountingOrganisationId
    })
  })

  /**
   * ONGOING
   */
  page(`${baseRoute}/:dataSyncId`, async function (context) {
    await appStarterPg()

    const { dataSyncId } = context.params

    showAdminSyncDetails({
      containerElementId: contentElementId,
      browserAppUser,
      dataSyncId
    })

    // showEntities()
  })

  // Init the router
  page()
}
